// ContactPage.js
import React from 'react';

function ContactPage() {
  return (
    <div>
      <h2>Contact Us</h2>
      <p>Please send all inquiries to: general@chaind.co.site</p>
    </div>
  );
}

export default ContactPage;